
import React from "react";
import { cn } from "../utils/utils";

const Button = (props) => {
  const { children, className,onClick,tabIndex } = props;

  return <button onClick={onClick} className={cn(" py-2 px-4 bg-primary-20 rounded-lg", className)} tabIndex={tabIndex}>{children}</button>;
};

export default Button;
